import React from "react";
import {Helmet} from "react-helmet";

export default function NCEE() {
    return (
        <div>
            <Helmet>
                <title>高考 National College Entrance Examination</title>
            </Helmet>
            <h6 className="App-essay-title">高考</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 七月</b>
                <br/><br/>
                高考的理综卷子我倒着写的，因为我对物理很自信，但物理题的最后一问我并没有立刻解出来，还白白浪费了我40分钟，慌乱中我才重新开始做。事实证明，这个顺序对我成绩影响不大。
                <br/><br/>
                我的高考英语成绩远没有体现我本身的英语水平，语文作文也不远及我平时文章水平的万一。那年数学很简单，差一分满分，我也不清楚到底忘写了哪个“解”。但清华里有大把的数学满分，所以我丢了一分属于成绩一般。
                <br/><br/>
                十年前，全中国一半的状元去了清华，其中一半去了清华建筑系。我无法形容这个情况下的自负含量，因为这类自负被多次证明是毫无意义的。但我可以形容：
                <br/><br/>
                <ol>
                    <li>人不需要完美，差不多正常发挥，就够用了。</li><br/>
                    <li>风水轮流转，十年前清华建筑呼风唤雨，计算机系还远不配被我们称作“贵系”。但现在我也得在科技行业吃饭。如今科技圈很多顶级人才目空一切，眼高于顶。别忘了，我对这种眼神很熟悉。这种事，骗一次就够了。</li><br/>
                    <li>人的头衔不重要。有何成绩，有何工作，有何成就，最后都会归零。但衡量一个人成就的重要标准，是看：这个人能否自由地支配自己的时间和言行。</li><br/>
                    <li>恭喜各位考生，高考结束后，无论你是清华北大还是没参加考试，人生都凛冬已至。往后活着需要更加专心。因为游戏的筹码不再是分数，而是自己的尊严和命运。</li>
                </ol>
                祝好运🌹

            </p>

            <br/>

            <h6 className="App-essay-title">National College Entrance Examination</h6>
            <p className="App-essay-article">
                <br/>
                <b>Jul 2025</b>
                <br/><br/>

            </p>
        </div>)
}
